import { ui } from '@joint/plus';

export class HaloService {
  create(cellView) {
    const halo = new ui.Halo({
      cellView,
      boxContent: null,
      handles: this.getHaloConfig(),
      useModelGeometry: false,
    });
    halo.render();
  }

  getHaloConfig() {
    return [];
  }
}
